<!--
    描述：组织结构
    日期：2021/04/27
    作者：zwh
-->
<template>
    <div class="w-page-main">
        <div class="w-page-header superiors-search-area">
            <div class="left-text overflow-hidden">
                <span><b>数据权限列表</b></span>
            </div>
            <div class="btnGroups">
                <el-button type="success"
                           size="small"
                           icon="el-icon-check"
                           v-if="roleBtns.includes('group_role_data_permission_save') && userInfo.roleType === 1"
                           @click="saveClick()">保存</el-button>
            </div>
        </div>

        <div class="w-page-container pdb10">
            <div class="w-table-layout">
                <div class="w-table-content"
                     ref="content">
                    <el-table ref="treeTable"
                              v-loading="treeTableObj.loading"
                              :data="treeTableObj.data"
                              default-expand-all
                              :height="treeTableObj.tableH"
                              row-key="id"
                              border
                              highlight-current-row>
                        <el-table-column type="index"
                                         align="center"
                                         width="55">
                            <template slot="header" slot-scope="scope">
                                <div></div>
                            </template>
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.isChecked" @change="handleCheck($event, scope.row)"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sname"
                                         label="部门名称"
                                         show-overflow-tooltip
                                         min-width="150"></el-table-column>
                        <el-table-column prop="dataScope"
                                         label="权限范围"
                                         show-overflow-tooltip
                                         min-width="150">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row[scope.column.property]"
                                           placeholder=""
                                           size="small"
                                           @change="authScopeSelectChange($event, scope.row)">
                                    <el-option v-for="item in authScopeSelectList"
                                               :key="item.id"
                                               :label="item.sname"
                                               :value="item.value"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { getDictByParentValue} from 'api/system/sys.js'
import {
	getGroupStationByGroupId,
} from 'api/system/sysStation.js'
import {
	saveRoleDataPermission,
	getAuthScopeData
} from 'api/system/sysGroupRoleDataPermission.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            //权限选择下拉信息
            authScopeSelectList : [],
            //部门树对象
            treeTableObj: {
                loading: false,
                tableH: 200,
                oriData: [],
                data: [],

                expandKeys: []
            },
            defaultProps: {
                children: 'children',
                label: 'sname'
            },
            //默认选择信息
            treeDefaultCheckedKey: [],
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeTableObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    // 缓存页面进入时
    activated() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeTableObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    },
    watch: {
        clientSize(val) {
            this.treeTableObj.tableH = this.$refs.content.offsetHeight
        }
    },
    created() {
        this.getAuthScopeDict()
    },
    methods: {
        init(obj){
            let that = this
            that.groupId = obj.groupId
            that.roleId = obj.roleId
            that.menuId = obj.menuId

            that.checkedList = []
            this.getGroupStationInfo()

            if(that.groupId == '' || that.roleId == '' || that.menuId == '') {
                that.treeTableObj.data = that.treeTableObj.oriData.concat()
                return
            }

            this.getAuthScopeInfo()
        },
        // 初始获取数据
        getGroupStationInfo() {
            let that = this
            let param = {
                groupId : this.groupId
            }
            getGroupStationByGroupId(param).then(res => {
                that.treeTableObj.oriData = that.$utils.toArrayTree(res.data)
                that.treeTableObj.data = that.treeTableObj.oriData.concat()
            })
        },
        //获取权限数据信息
        getAuthScopeInfo(){
            let that = this
            let param = { groupId : that.groupId, roleId: that.roleId, menuId: that.menuId }
            getAuthScopeData(param).then(res => {
                if (res.operationCode == 1) {
                    that.treeTableObj.oriData = that.$utils.toArrayTree(res.data.deptTreeList)
                    that.treeTableObj.data = that.treeTableObj.oriData.concat()
                    that.checkedList = res.data.deptTreeList.concat()
                    setTimeout(() => {
                        this.treeTableObj.tableH = this.$refs.content.offsetHeight
                    }, 100)
                }
            })
        },

        // 确定按钮事件
        saveClick(obj) {
            let that = this

            if (that.groupId == '') {
                that.$message({ message: '请选择用户组信息', type: 'warning' })
                return
            }
            if (that.roleId == '') {
                that.$message({ message: '请选择角色信息', type: 'warning' })
                return
            }
            if (that.menuId == '') {
                that.$message({ message: '请选择菜单信息', type: 'warning' })
                return
            }

            let dataAuthSelection = that.checkedList.filter(x => x.isChecked)
            let dataList = dataAuthSelection.map(x => {
                let obj = {
                    stationId: x.id,
                    dataScope: x.dataScope,
                }
                return obj
            })
            let param = {
                groupId: that.groupId,
                roleId: that.roleId,
                menuId: that.menuId,
                dataAuthSelection: dataList
            }
            saveRoleDataPermission(param).then(res => {
                if (res.operationCode == 1) {
                    that.$message({ message: '保存成功', type: 'success' })
                }
            })
        },

        // 获取数据权限 范围码表
        getAuthScopeDict() {
            let that = this
            let param = { value: 1004 }
            getDictByParentValue(param).then(res => {
                if (res.operationCode == 1) {
                    that.authScopeSelectList = res.data
                }
            })
        },
        // 数据权限复选框 check 事件
        handleCheck(status, row) {
            let _item = this.checkedList.find(x => x.id === row.id)

            if (_item) {
                _item.isChecked = status
            }
        },

        // 权限范围切换事件
        authScopeSelectChange(value, row) {
            let _item = this.checkedList.find(x => x.id === row.id)

            if (_item) {
                _item.dataScope = value
            }
        },
    }
}
</script>
<style lang="less">

</style>